<template>
  <div class="layout-container">
    <el-tabs type="border-card">
      <el-tab-pane label="专题列表">
        <div style="background: #ffffff; position: relative">
          <div class="search-condition-con" :class="'show'">
            <div class="search-condition">
              <span class="label">站点</span>
              <div class="input-condition">
                <site-auto-complete
                  v-model="condition.site_id"
                  :clueId="1"
                  :init-choose-first="true"
                  :owned="true"
                  ref="siteAutoComplete"
                  @created="initData"
                  clearable
                ></site-auto-complete>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">专题标题</span>
              <div class="input-condition">
                <el-input
                  v-model="condition.name"
                  placeholder="请输入专题标题"
                ></el-input>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">上传人</span>
              <div class="input-condition">
                <el-input
                  v-model="condition.creator"
                  placeholder="请输入上传人"
                ></el-input>
              </div>
            </div>
            <div class="search-condition" style="width: 40%; max-width: 500px">
              <span class="label">上传时间</span>
              <div class="input-condition">
                <el-date-picker
                  v-model="condition.date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="btn-condition">
            <el-button type="primary" @click="handleSearch()">查 询</el-button>
            <el-button @click="resetSearch()">清空条件</el-button>
          </div>
        </div>
        <div class="clearfix" style="margin-bottom: 20px">
          <el-button-group class="floatL">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd()"
              v-permission="'operating.topic.create'"
              >上传专题文件</el-button
            >
          </el-button-group>
        </div>
        <el-table
          :data="list"
          style="width: 100%"
          :highlight-current-row="true"
          stripe
          tooltip-effect="dark"
          ref="multipleTable"
          v-loading="isLoading"
          header-cell-class-name="table-back"
        >
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="专题名称" prop="name"></el-table-column>
          <el-table-column label="上传人" prop="creator"></el-table-column>
          <el-table-column
            label="上传时间"
            prop="created_at"
            align="center"
          ></el-table-column>
          <el-table-column label="链接类型" prop="link_type">
            <template slot-scope="scope">
              <span v-if="scope.row.link_type == 0">PC端链接</span>
              <span v-if="scope.row.link_type == 1">M端链接</span>
              <span v-if="scope.row.link_type == 2">自适应链接</span>
              <el-button
                class="copy"
                size="mini"
                @click="copyLink(scope.row.url)"
                >复制链接</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="300">
            <template slot="header" slot-scope="scope">
              <span style="color: #409eff">操作</span>
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-permission="'operating.topic.edit'"
                @click="openEdit(scope.row.id, scope.row.site_id)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-permission="'operating.topic.delete'"
                @click="deletZT(scope.row.id, scope.row.site_id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <template v-if="list.length > 0">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :current-page="condition.page"
            :total="condition.total"
            :page-size="condition.per_page"
            @current-change="currentChange"
          ></el-pagination>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
import { getSite, getSitesAutoComplete } from "@/service/site";
import { parseTime } from "@/utils";
import { getZhuantiList, deleteTopic } from "@/service/zhuanti";

export default {
  name: "List",
  components: {
    SiteAutoComplete,
  },
  data() {
    return {
      list: [],
      condition: {
        site_id: null,
        creator: null,
        name: null,
        data: [],
        page: 1,
        total: null,
        per_page: 10
      },
      isLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    async getConfigs() {
      await getSite({ agent_status: 0, per_page: 1000 }).then((data) => {
        this.siteAll = data.data;
      });
      await getSitesAutoComplete({}).then((data) => {
        this.siteList = data;
      });
    },
    handleAdd(index, row) {
      this.$router.push("add");
    },
    openEdit(id, siteId) {
      this.$router.push({
        path: "/operation/topic/edit",
        query: { id: id, siteId: siteId },
      });
    },
    handleSearch() {
      if (this.condition.date && this.condition.date.length > 0) {
        this.condition.created_at_start = parseTime(this.condition.date[0]);
        this.condition.created_at_end = parseTime(this.condition.date[1]);
      }
      this.initData();
    },
    resetSearch() {
      this.condition = {
        site_id: null,
        creator: null,
        name: null,
        data: [],
        page: 1,
        total: null,
        per_page: 10
      };
      this.$nextTick(() => {
        this.$refs.siteAutoComplete && this.$refs.siteAutoComplete.reset();
      });
    },
    async initData() {
      this.isLoading = true;
      await getZhuantiList(this.condition).then((data) => {
        this.list = [];
        this.list = data.data;
        this.condition.total = parseInt(data.total);

      });
      this.isLoading = false;
    },
    currentChange (index) {
      this.condition.page = index
      this.initData()
    },
    copyLink(url = "") {
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
    deletZT(id, site_id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let query = {};
        query.site_id = site_id;
        deleteTopic(id, query)
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.initData();
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err.message || "删除失败",
            });
          });
      });
    },
  },
};
</script>

<style scoped>
.copy {
  margin-left: 10px;
}
</style>
